import { render, staticRenderFns } from "./MeitavDash.vue?vue&type=template&id=36d276b2&"
import script from "./MeitavDash.vue?vue&type=script&lang=js&"
export * from "./MeitavDash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports